import { MdOutlineCheckCircleOutline } from "../../assets/icons/vander";

export const SuccessMessage = ({ children, className }) => {
  return (
    <div
      className={`alert bg-soft-success fw-medium mb-0 ${className}`}
      role="alert"
    >
      <MdOutlineCheckCircleOutline className="fs-5 align-middle me-1" />{" "}
      {children}
    </div>
  );
};
